export var StrategyAttributePlatformName;
(function (StrategyAttributePlatformName) {
    StrategyAttributePlatformName["Linux"] = "linux";
    StrategyAttributePlatformName["Windows"] = "windows";
    StrategyAttributePlatformName["Macos"] = "macos";
    StrategyAttributePlatformName["Android"] = "android";
    StrategyAttributePlatformName["Ios"] = "ios";
})(StrategyAttributePlatformName || (StrategyAttributePlatformName = {}));
//# sourceMappingURL=strategy-attribute-platform-name.js.map